import { env } from '@/environment';

const getEnvTimeSettings = () => ({
  revalidate: +env.NEXT_CACHE_TIME,
  timeout: +env.NEXT_FETCH_TIMEOUT * 1000,
});

export default getEnvTimeSettings;
